import * as yup from "yup";
import { isValidPhoneNumber } from "react-phone-number-input";

export const verifyEmailSchema = yup.object().shape({
    email: yup.string().email().required('Email is required'),
}).required();
export const verifyPhoneSchema = yup.object().shape({
    // Digits-only rejected "+", so a country code could not be supplied and the
    // stored value was never valid E.164 — which Twilio requires, and which the
    // unique phone index compares literally.
    phone: yup
        .string()
        .required('Phone is required')
        .test('e164', 'Enter a valid phone number with its country code', (value) =>
            !!value && isValidPhoneNumber(value)
        ),
}).required();
export const verifyEmailCodeSchema = yup.object().shape({
    otpCode: yup.string().required('Code is required'),
}).required();